var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DemandService from '../../api/DemandService';
import ServiceService from '../../api/ServiceService';
var DemandDetailDialog = (function (_super) {
    __extends(DemandDetailDialog, _super);
    function DemandDetailDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showPayment = false;
        _this.showQRCode = false;
        _this.paymentType = '';
        _this.paymentQRCode = '';
        _this.showShareDialog = false;
        _this.shareQRCodeUrl = '';
        _this.shareLoading = false;
        _this.paymentTimer = null;
        _this.currentOrderId = '';
        _this.vipPrices = {
            year: 680,
            yearOriginal: 2499,
            month: 68,
            monthOriginal: 399
        };
        _this.singlePrice = 4.9;
        _this.vipBenefits = [];
        return _this;
    }
    Object.defineProperty(DemandDetailDialog.prototype, "shouldShowFullContent", {
        get: function () {
            if (this.demandInfo.money <= 0)
                return true;
            if (this.demandInfo.is_need_pay === 0)
                return true;
            if (this.isPaidUser)
                return true;
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemandDetailDialog.prototype, "isHtmlContent", {
        get: function () {
            if (!this.demandInfo || !this.demandInfo.description)
                return false;
            var description = this.demandInfo.description;
            var htmlTagPattern = /<[^>]+>/;
            return htmlTagPattern.test(description);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemandDetailDialog.prototype, "isMarkdownContent", {
        get: function () {
            if (!this.demandInfo || !this.demandInfo.description || this.isHtmlContent)
                return false;
            var description = this.demandInfo.description;
            var markdownPatterns = [
                /^#{1,6}\s/,
                /^\*\s/,
                /^-\s/,
                /^\d+\.\s/,
                /\*\*.*\*\*/,
                /\*.*\*/,
            ];
            return markdownPatterns.some(function (pattern) { return pattern.test(description); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemandDetailDialog.prototype, "renderedMarkdown", {
        get: function () {
            if (!this.isMarkdownContent)
                return '';
            return this.renderMarkdownToHtml(this.demandInfo.description);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemandDetailDialog.prototype, "previewRenderedMarkdown", {
        get: function () {
            if (!this.isMarkdownContent)
                return '';
            return this.renderMarkdownToHtml(this.previewContent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemandDetailDialog.prototype, "previewContent", {
        get: function () {
            if (!this.demandInfo || !this.demandInfo.description)
                return '';
            var description = this.demandInfo.description;
            return description;
        },
        enumerable: true,
        configurable: true
    });
    DemandDetailDialog.prototype.created = function () {
        this.demandService = DemandService.getInstance();
        this.serviceService = ServiceService.getInstance();
        this.loadVipPrices();
        if (this.demandInfo && this.demandInfo.money > 0) {
            this.singlePrice = this.demandInfo.money;
        }
    };
    DemandDetailDialog.prototype.showPaymentDialog = function () {
        this.showPayment = true;
        this.paymentType = 'year';
    };
    DemandDetailDialog.prototype.closePaymentDialog = function () {
        this.showPayment = false;
        this.paymentType = '';
        this.clearPaymentTimer();
    };
    DemandDetailDialog.prototype.selectPaymentType = function (type) {
        this.paymentType = type;
    };
    DemandDetailDialog.prototype.handleVipSectionClick = function () {
        if (this.paymentType !== 'year' && this.paymentType !== 'month') {
            this.paymentType = 'year';
        }
    };
    DemandDetailDialog.prototype.handlePayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.paymentType) {
                            this.$message.warning('请选择支付方式');
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.getPaymentQRCode(this.paymentType)];
                    case 2:
                        response = _a.sent();
                        this.paymentQRCode = response.qrcode_url;
                        this.showPayment = false;
                        this.showQRCode = true;
                        if (response.order_id) {
                            this.startPaymentPolling(response.order_id);
                        }
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.$message.error('获取支付信息失败');
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.loadVipPrices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, config_data, rechargeList, vipList, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.demandService.getMemberRights({ coupon: 1 })];
                    case 1:
                        response = _a.sent();
                        if (response.data.success) {
                            data = response.data.data;
                            config_data = data.config_data;
                            rechargeList = config_data.filter(function (item) { return item.key === 'bill_plan_config'; });
                            if (rechargeList.length > 0) {
                                rechargeList = rechargeList[0].map || [];
                                rechargeList.forEach(function (item) {
                                    if (item.key === 'yearly_card') {
                                        _this.vipPrices.year = item.value;
                                        _this.vipPrices.yearOriginal = item.strikethrough_price;
                                    }
                                    else if (item.key === 'monthly_card') {
                                        _this.vipPrices.month = item.value;
                                        _this.vipPrices.monthOriginal = item.strikethrough_price;
                                    }
                                });
                            }
                            vipList = config_data.filter(function (item) { return item.key !== 'bill_plan_config'; });
                            this.vipBenefits = vipList;
                        }
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('加载价格配置失败:', error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.getPaymentQRCode = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var orderResponse, payment_type, vipType, amount, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        orderResponse = void 0;
                        payment_type = 12;
                        if (!(type === 'single')) return [3, 2];
                        return [4, this.demandService.createSingleOrder({
                                payment_type: payment_type,
                                money: this.singlePrice,
                                business_demand_id: this.demandInfo.business_demand_id
                            })];
                    case 1:
                        orderResponse = _a.sent();
                        return [3, 4];
                    case 2:
                        vipType = type === 'month' ? 1 : 2;
                        amount = type === 'month' ? this.vipPrices.month : this.vipPrices.year;
                        return [4, this.demandService.rechargeVip({
                                type: vipType,
                                recharge_money: amount,
                                business_demand_id: this.demandInfo.business_demand_id,
                                payment_type: payment_type
                            })];
                    case 3:
                        orderResponse = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (orderResponse.data.code === 0 && orderResponse.data.data) {
                            return [2, {
                                    qrcode_url: orderResponse.data.data.qrcode_path,
                                    order_id: orderResponse.data.data.order_id,
                                    pay_info: orderResponse.data.data.pay_info || ''
                                }];
                        }
                        else {
                            throw new Error(orderResponse.data.msg || '创建订单失败');
                        }
                        return [3, 6];
                    case 5:
                        error_3 = _a.sent();
                        throw error_3;
                    case 6: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.closeQRCode = function () {
        this.showQRCode = false;
        this.paymentQRCode = '';
        this.clearPaymentTimer();
    };
    DemandDetailDialog.prototype.refreshContent = function () {
        this.$emit('refresh-content');
    };
    DemandDetailDialog.prototype.refreshDemandDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.demandService.getDemandDetail(this.demandInfo.business_demand_id)];
                    case 1:
                        response = _a.sent();
                        if (response.data.code === 0 && response.data.data) {
                            Object.assign(this.demandInfo, response.data.data);
                            this.refreshContent();
                        }
                        return [3, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error('重新获取招标详情失败:', error_4);
                        this.refreshContent();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.handleShare = function () {
        this.showShareDialog = true;
        this.generateMiniProgramQRCode();
    };
    DemandDetailDialog.prototype.generateMiniProgramQRCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, result, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.demandInfo)
                            return [2];
                        this.shareLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, this.demandService.getMiniProgramQRCode({ business_demand_id: this.demandInfo.business_demand_id, demand_type: this.demandInfo.demand_type })];
                    case 2:
                        response = _a.sent();
                        result = response.data;
                        if (result.code === 0) {
                            this.shareQRCodeUrl = result.data.url;
                            console.log(this.shareQRCodeUrl);
                        }
                        else {
                            throw new Error(result.msg || '生成二维码失败');
                        }
                        return [3, 5];
                    case 3:
                        error_5 = _a.sent();
                        console.error('生成小程序二维码失败:', error_5);
                        this.$message.error('生成分享二维码失败，请稍后重试');
                        return [3, 5];
                    case 4:
                        this.shareLoading = false;
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.closeShareDialog = function () {
        this.showShareDialog = false;
        this.shareQRCodeUrl = '';
    };
    DemandDetailDialog.prototype.startPaymentPolling = function (orderId) {
        var _this = this;
        this.currentOrderId = orderId;
        this.clearPaymentTimer();
        this.paymentTimer = setInterval(function () {
            _this.checkPaymentStatus(orderId);
        }, 3000);
        setTimeout(function () {
            _this.clearPaymentTimer();
        }, 15 * 60 * 1000);
    };
    DemandDetailDialog.prototype.checkPaymentStatus = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, payData, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.serviceService.getPayFlag({ order_id: orderId })];
                    case 1:
                        response = _a.sent();
                        if (response.data.code === 0 && response.data.data) {
                            payData = response.data.data;
                            if (payData.is_pay === 1) {
                                this.clearPaymentTimer();
                                this.closeQRCode();
                                this.$message.success('支付成功！');
                                this.$emit('payment-success');
                                this.refreshDemandDetail();
                            }
                        }
                        return [3, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error('查询支付状态失败:', error_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    DemandDetailDialog.prototype.clearPaymentTimer = function () {
        if (this.paymentTimer) {
            clearInterval(this.paymentTimer);
            this.paymentTimer = null;
        }
    };
    DemandDetailDialog.prototype.renderMarkdownToHtml = function (markdown) {
        if (!markdown)
            return '';
        var html = markdown;
        html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
        html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');
        html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>');
        html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
        html = html.replace(/^\* (.*$)/gim, '<li>$1</li>');
        html = html.replace(/^- (.*$)/gim, '<li>$1</li>');
        html = html.replace(/^\d+\. (.*$)/gim, '<li>$1</li>');
        html = html.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        html = html.replace(/<\/ul>\s*<ul>/g, '');
        html = html.replace(/\n\n/g, '</p><p>');
        html = html.replace(/\n/g, '<br>');
        if (!html.startsWith('<h') && !html.startsWith('<ul') && !html.startsWith('<p>')) {
            html = '<p>' + html + '</p>';
        }
        return html;
    };
    __decorate([
        Prop({
            type: Object,
            required: true
        })
    ], DemandDetailDialog.prototype, "demandInfo", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], DemandDetailDialog.prototype, "needPay", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], DemandDetailDialog.prototype, "isPaidUser", void 0);
    DemandDetailDialog = __decorate([
        Component
    ], DemandDetailDialog);
    return DemandDetailDialog;
}(Vue));
export default DemandDetailDialog;
